// @ts-nocheck
import { GetShipTosApiParameter } from "@insite/client-framework/Services/CustomersService";
import translate from "@insite/client-framework/Translate";
import { ShipToCollectionModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";
import { ApiHandler } from "@toolkit/Modules/client-framework/HandlerCreator";

const handleGetShipTosResult: ApiHandler<GetShipTosApiParameter, ShipToCollectionModel> = props => {
    const state = props.getState();
    const includeCurrentTag = Boolean(props.apiParameter.additionalExpands?.includes("includeCurrentTag"));
    const includeShowMy = Boolean(props.apiParameter.additionalExpands?.includes("includeShowMy"));
    const showAllTranslation = translate("Show All");

    if (props.apiResult.shipTos) {
        const newShipTosOptions = props.apiResult?.shipTos.reduce((shipTos: ShipToModel[], shipTo: ShipToModel) => {
            let _shipTo = shipTo;

            // The "Show All" ship to id returns a translated value, so it changes depending on language
            if (shipTo.id === showAllTranslation) {
                _shipTo = { ..._shipTo, label: translate("Show All Ship To Locations") };
            }

            if (includeCurrentTag && shipTo.id === state.context.session.shipToId) {
                _shipTo = { ..._shipTo, label: `[${translate("CURRENT")}] ${shipTo.label}` };
            }

            return shipTos.concat(_shipTo);
        }, []);

        if (includeShowMy && props.apiResult?.shipTos.length > 2) {
            const showMyShipTos: ShipToModel = {
                address1: "",
                address2: "",
                address3: "",
                address4: "",
                attention: "",
                city: "",
                companyName: "",
                contactFullName: "",
                country: null,
                customerName: "",
                customerNumber: "",
                customerSequence: newShipTosOptions
                    .filter(x => x.customerSequence !== "-1")
                    .map(x => x.customerSequence)
                    .join(","),
                email: "",
                fax: "",
                firstName: "",
                fullAddress: "",
                id: "Show My Ship-Tos",
                isDefault: false,
                isNew: false,
                isVmiLocation: false,
                label: translate("Show My Ship-Tos"),
                lastName: "",
                oneTimeAddress: false,
                phone: "",
                postalCode: "",
                state: null,
                validation: null,
                properties: {},
                uri: "",
            };
            newShipTosOptions.splice(1, 0, showMyShipTos);
        }

        props.apiResult.shipTos = newShipTosOptions;
    }
};

export default handleGetShipTosResult;
